module.exports = __webpack_public_path__ + "static/scale-model-of-blandwood-mansion-in-greensboro-north-carolina-3086693761b5365730dab966a6d1b734.png";